import axios from 'axios';

// 请假天数设置
export function leaveDaysSet(data) {
  return axios({
    url: '/fy/setting/leaveDaysSet',
    method: 'POST',
    data: data,
  });
}

// 请假天数更新
export function leaveDaysUpdate(data) {
  return axios({
    url: '/fy/setting/leaveDaysUpdate',
    method: 'POST',
    data: data,
  });
}

// 删除请假天数
export function leaveDaysDelete(data) {
  return axios({
    url: '/fy/setting/leaveDaysDelete',
    method: 'POST',
    data: data,
  });
}

// 年级下拉选（fy:setting:gradeList）
export function gradeList(params) {
  return axios({
    url: '/fy/setting/gradeList',
    method: 'GET',
    params: params,
  });
}

// 创建级部、更新
export function subGradeCreate(data) {
  return axios({
    url: '/fy/setting/subGradeCreate',
    method: 'POST',
    data: data,
  });
}

// 删除级部(fy:setting:subGradeCreate)
export function subGradeDel(data) {
  return axios({
    url: '/fy/setting/subGradeDel',
    method: 'POST',
    data: data,
  });
}

// 根据年级id获取所有班级(fy:setting:bindClassToSubGrade)
export function getClassListByGradeId(params) {
  return axios({
    url: '/fy/setting/getClassListByGradeId',
    method: 'GET',
    params: params,
  });
}

// 绑定班级到级部(fy:setting:bindClassToSubGrade)
export function bindClassToSubGrade(data) {
  return axios({
    url: '/fy/setting/bindClassToSubGrade',
    method: 'POST',
    data: data,
  });
}

// 设置审核教师
export function auditTeacherSet(data) {
  return axios({
    url: '/fy/setting/auditTeacherSet',
    method: 'POST',
    data: data,
  });
}
